import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { fillTemplateWithData, modelServiceJsonToIntegrationStoreData, PARSABLE_PROPS } from '../../routines';
import {
    EOnError,
    EOperator,
    FullIntegrationStoreData,
    IExternalIntegrationCall,
} from '../../tp-integrations.interface';

@Component({
    template: '',
})
export abstract class AbstractCallComponent implements OnInit {

    @Input() dataStore!: FullIntegrationStoreData;
    @Input() call!: IExternalIntegrationCall;
    @Input() debug: boolean = false;

    @Output() callEnd: EventEmitter<FullIntegrationStoreData> = new EventEmitter();
    @Output() callThrowError: EventEmitter<string> = new EventEmitter();

    target: string | null = null;

    result: any;

    _showLoading: boolean = false;

    operatorHandlerMap: Record<EOperator, (value: string, valueTrigger: string) => boolean> = {
        [EOperator.GREATER]: (value, valueTrigger) => value > valueTrigger,
        [EOperator.EQUAL]: (value, valueTrigger) => value === valueTrigger,
        [EOperator.GREATER_EQUAL]: (value, valueTrigger) => value >= valueTrigger,
        [EOperator.LESS]: (value, valueTrigger) => value < valueTrigger,
        [EOperator.LESS_EQUAL]: (value, valueTrigger) => value <= valueTrigger,
        [EOperator.NOT_EQUAL]: (value, valueTrigger) => value !== valueTrigger,
    };

    get showLoading() {
        return this._showLoading;
    }

    set showLoading(loading: boolean) {
        setTimeout(() => (this._showLoading = loading));
    }

    ngOnInit(): void {
        this.target = this.call.target ?? null;
        if (this.debug) {
            console.log('INTEGRATIONS abstractCall ngInit()', { target: this.target, datStore: this.dataStore });
        }
    }

    async callInit() {
        this.result = await this.run();
        this.end();
    }

    protected async run(): Promise<any> {
        return null;
    }


    protected parseAllSourceWithDataStore(call: IExternalIntegrationCall, _pre: string = 'B_'): Partial<IExternalIntegrationCall> {
        const pre = `{${_pre}`;

        const parsedProps = PARSABLE_PROPS.map((prop) => {
            const propValue = call[prop];

            if (typeof propValue === 'string' && propValue.indexOf('{B_') !== -1) {
                return [prop, fillTemplateWithData(this.dataStore, call.placeholders, propValue, _pre)];
            } else if (typeof propValue === 'object' && propValue) {
                const parsedValue = JSON.parse(JSON.stringify(propValue), (key, value) => {
                    if (typeof value !== 'string' || value.indexOf('{B_') === -1) return value;

                    const splitted = value.split('_');
                    if (splitted.length === 2 && splitted[0] === '{B' && splitted[1].endsWith('}')) {
                        /*siamo sicuri che ci sia un solo {B_x} senza altre stringhe inserire direttamente il valore B_x senza altre elaborazioni
                         cosi si evita il caso in cui la stringa interpolata contenga un 'oggetto non parsabile per via degli apici esterni*/
                        const bIndex = parseInt(splitted[1].substring(0, splitted[1].length - 1));
                        const placeholderPath = call.placeholders[bIndex];
                        return this.dataStore[placeholderPath];
                    } else {
                        return fillTemplateWithData(this.dataStore, call.placeholders, value, _pre);
                    }
                });
                return [prop, parsedValue];
            }
            return [prop, call[prop]];
        });
        return Object.fromEntries(parsedProps);
    }

    protected end() {
        const output: FullIntegrationStoreData = {};
        if (this.debug) {
            console.log('INTEGRATIONS abstractCall end()', { result: this.result, target: this.target });
        }
        /*ci devono essere sia target che result altrimenti l'output e` vuoto. come accade negli iframe
         * nelle rest invece ci aspettiamo che entrambi siano settati*/
        if (this.target) output[this.target] = this.result;
        this.callEnd.emit(modelServiceJsonToIntegrationStoreData(output));
    }

    protected errorValueHandler(value: string): boolean {
        const { errorHandling } = this.call;

        if (this.debug) {
            console.log('INTEGRATIONS abstractCall erroValueHandler()', { value, errorHandling });
        }

        if (!errorHandling || errorHandling.operator === undefined) return false;
        if (!this.operatorHandlerMap[errorHandling.operator]) return false;
        return this.operatorHandlerMap[errorHandling.operator](value, errorHandling.valueTrigger);
    }
}
